import { z } from "zod";

export const deductionSchema = z.object({
  amount: z.number(),
  codename: z.string(),
  payer: z.enum(["EE", "ER"]),
});
